const cards = [
  {
    title: '热门电视剧',
    desc: '收录全网热播国产剧、韩剧、美剧、日剧，每日同步更新最新剧集，追剧不等待。从《藏海花》到《长相思》，高分好剧一网打尽。',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20drama%20series%2C%20soft%20evening%20lighting%2C%20comfortable%20sofa%2C%20popcorn%20bowl%2C%20cinematic%20color%20grading%2C%20warm%20amber%20and%20soft%20red%20tones%2C%20home%20theater%20vibe&width=800&height=500&seq=tv-card-01&orientation=landscape',
  },
  {
    title: '院线大片',
    desc: '最新上映电影全网首发，涵盖动作、喜剧、科幻、悬疑等全类型。高清画质在线播放，免去下载等待，随时随地看大片。',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Movie%20theater%20screen%20with%20dramatic%20cinematic%20lighting%2C%20red%20velvet%20curtains%2C%20empty%20seats%20with%20warm%20ambient%20glow%2C%20film%20projector%20beam%2C%20classic%20cinema%20aesthetic%2C%20rich%20deep%20colors%2C%20artistic%20composition&width=800&height=500&seq=movie-card-02&orientation=landscape',
  },
  {
    title: '人气综艺',
    desc: '热门综艺节目实时更新，搞笑、音乐、竞技、旅行类综艺全覆盖。周末宅家必备，轻松一刻尽在番茄影视大全。',
    icon: 'ri-emotion-laugh-line',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20set%20with%20variety%20show%20atmosphere%2C%20stage%20lights%2C%20cheerful%20vibe%2C%20entertainment%20show%20production%2C%20vibrant%20warm%20tones%2C%20modern%20broadcast%20studio%2C%20dynamic%20lighting&width=800&height=500&seq=variety-card-03&orientation=landscape',
  },
  {
    title: '经典动漫',
    desc: '日漫、国漫、欧美动画全收录，从经典怀旧到最新番剧。高清画质、中文字幕，动漫迷的理想追番聚集地。',
    icon: 'ri-ghost-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20warm%20golden%20evening%20light%2C%20cozy%20room%20with%20anime%20posters%20on%20wall%2C%20soft%20atmospheric%20lighting%2C%20artistic%20Japanese%20animation%20aesthetic%2C%20warm%20color%20palette%2C%20creative%20composition&width=800&height=500&seq=anime-card-04&orientation=landscape',
  },
  {
    title: '纪录片频道',
    desc: 'BBC、Discovery、央视等精品纪录片合集。自然、历史、科技、人文类目齐全，足不出户看世界，涨知识必备。',
    icon: 'ri-earth-line',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20warm%20golden%20hour%20lighting%2C%20sweeping%20landscape%2C%20cinematic%20aerial%20view%2C%20soft%20atmospheric%20haze%2C%20natural%20warm%20earth%20tones%2C%20documentary%20film%20aesthetic%2C%20epic%20scale%20composition&width=800&height=500&seq=doc-card-05&orientation=landscape',
  },
  {
    title: '少儿专区',
    desc: '精选优质儿童动画、教育节目和亲子内容，安全健康的观影环境。寓教于乐，让孩子开心，家长放心。',
    icon: 'ri-hearts-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20childrens%20playroom%20with%20warm%20sunlight%2C%20colorful%20toys%2C%20soft%20carpet%2C%20bookshelf%20with%20picture%20books%2C%20gentle%20pastel%20warm%20tones%2C%20safe%20and%20happy%20atmosphere%2C%20creative%20playful%20setting&width=800&height=500&seq=kids-card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">海量内容 · 一站畅享</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大核心分类覆盖全网热门影视资源，无论你是剧迷、影迷还是综艺咖，都能找到属于你的精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-10 h-10 rounded-xl bg-primary-500/90 flex items-center justify-center">
                  <i className={`${card.icon} text-background-50 text-lg`}></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}